import React, { Fragment, useEffect, useState } from 'react';
import MajorTemplate from '../../components/templates/majorTemplate/MajorTemplate';
import Footer from '../../components/templates/homePageSections/footer/Footer';
import HeaderSection from '../../components/organism/headerSection/HeaderSection';
import useScrollToTop from '../../app/hooks/useScrollToTop';
import Container from '../../components/hoc/container/Container';
import { navigationData } from './factory/data';
import Sections from './factory/sections';
import endpoints from '../../api/endpoints';
import { useGetQuery } from '../../services/apiCall';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Loader from '../../components/atoms/loader/Loader';
import PageHeader from '../../components/templates/pageHeader/PageHeader';

function Major() {
  useScrollToTop();
  const { id } = useParams();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const [section, setSection] = useState(1);
  const [manualLoading, setManualLoading] = useState(true);

  const apiUrl = endpoints.degrees.getDegreesById;
  const { data, refetch } = useGetQuery({
    apiUrl,
    params: [id],
  });

  const handleButtonClick = (label) => {
    setSection(label);
  };

  useEffect(() => {
    setManualLoading(true);
    refetch();
  }, [id]);

  useEffect(() => {
    if (data) {
      const timeout = setTimeout(() => {
        setManualLoading(false);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [data]);

  return (
    <Fragment>
      {manualLoading ? (
        <PageHeader isLoaded />
      ) : (
        <MajorTemplate
          handleButtonClick={handleButtonClick}
          navigationData={navigationData}
          data={data ?? []}
          currentLanguage={currentLanguage}
        />
      )}

      <Container>
        {manualLoading ? (
          <Loader fullPage />
        ) : (
          <Sections
            key={data?.degree?.id || id}
            id={section}
            data={data ?? []}
            currentLanguage={currentLanguage}
          />
        )}
      </Container>
    </Fragment>
  );
}

export default Major;
